// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.notification-wrapper {
  padding-top: 20px;
}

.row {
  display: flex;
  flex-direction: row;
  align-items: center;
}

.header-text {
  font-weight: bold;
  color: var(--ion-color-secondary-contrast);
}

.content-text {
  color: var(--ion-color-secondary-contrast);
}

.image {
  margin-right: 10px;
  height: 40px;
  width: 40px;
}`, "",{"version":3,"sources":["webpack://./src/app/components/snackbar-notification/snackbar-notification.component.scss"],"names":[],"mappings":"AAAA;EACI,iBAAA;AACJ;;AAEA;EACI,aAAA;EACA,mBAAA;EACA,mBAAA;AACJ;;AAEA;EACI,iBAAA;EACA,0CAAA;AACJ;;AAEA;EACI,0CAAA;AACJ;;AAEA;EACI,kBAAA;EACA,YAAA;EACA,WAAA;AACJ","sourcesContent":[".notification-wrapper {\r\n    padding-top: 20px;\r\n}\r\n\r\n.row {\r\n    display: flex;\r\n    flex-direction: row;\r\n    align-items: center;\r\n}\r\n\r\n.header-text {\r\n    font-weight: bold;\r\n    color: var(--ion-color-secondary-contrast);\r\n}\r\n\r\n.content-text {\r\n    color: var(--ion-color-secondary-contrast);\r\n}\r\n\r\n.image {\r\n    margin-right: 10px;\r\n    height: 40px;\r\n    width: 40px;\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
